import { Avatar, Box, Typography } from "@mui/material";
import { SwapyBaseBox } from "./SwapyBaseBox";

const truncateText = (text, maxLength = 20) => {
  if (!text) return "";
  return text.length > maxLength ? `${text.slice(0, maxLength - 3)}...` : text;
};

export function SwapyContainerTeam({ role = [], type, sxStyle, excludedUids = [] }) {
  const availableRole = role.filter((worker) => !excludedUids.includes(worker.uid));

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: 6,
        ...sxStyle,
      }}
    >
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          gap: 2,
          p: 4,
        }}
      >
        {availableRole.map((worker) => {
          const isDisabled = worker.isAvailable === true;

          return (
            <Box key={`wrapper-${type}-${worker.uid}`} display="flex" flexDirection="column">
              <SwapyBaseBox
                type={type}
                disabled={isDisabled}
                swapyName={`worker-${worker.uid}`}
                slotName={`available-${type}-${worker.uid}`}
                sxProp={{
                  display: "flex",
                  justifyContent: "left",
                  zIndex: 1,
                  color: "var(--fx-surface-text, #0F172A)",
                }}
              >
                <Avatar
                  sx={{
                    ml: "5px",
                    width: "40px",
                    height: "40px",
                  }}
                  src={worker.avatar}
                >
                  {worker.firstName?.charAt(0)}
                </Avatar>

                <Box width="100%">
                  <Typography sx={{ textAlign: "center" }} variant="caption">
                    {truncateText(`${worker.firstName} ${worker.lastName}`)}
                  </Typography>
                </Box>
              </SwapyBaseBox>

              {isDisabled && (
                <Typography
                  variant="caption"
                  color="error"
                  sx={{
                    mt: 1,
                    ml: 1,
                    fontSize: 12,
                  }}
                >
                  Current user is in another job at this moment
                </Typography>
              )}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
